export const ALLOWED_FILE_TYPES = [
  'jpg',
  'jpeg',
  'png',
  'webp',
  'pdf',
  'txt',
  'doc',
  'docx',
  'odt',
  'rtf',
  'md',
  'xls',
  'xlsx',
  'csv',
  'ods',
  'ppt',
  'pptx',
  'odp',
  'zip',
];

export const ALLOWED_EVIDENCE_FILE_TYPES = [...ALLOWED_FILE_TYPES, 'heic', 'heif'];

export const ALLOWED_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'webp', 'jfif'];

export const ALLOWED_ATTACHMENT_IMAGE_TYPES = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'tiff', 'bmp'];
export const ALLOWED_PURCHASE_INVOICE_TYPES = ['pdf', 'png', 'jpg', 'jpeg'];

export const MAX_FILE_SIZE_BYTES_99 = 99 * 1024 * 1024; // 99 MB
export const MAX_FILE_SIZE_BYTES_19 = 19 * 1024 * 1024; // 19 MB
export const MAX_FILE_SIZE_BYTES_100 = 100 * 1024 * 1024; // 100 MB
